import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import $ from 'jquery';
import 'datatables.net';
import { MdAddCircleOutline } from 'react-icons/md';
import AuthService from '../../services/AuthService';
import PropertyService from '../../services/PropertyService';


function Property() {
  const [Property, setProperty] = useState([]);
  const toast = useRef(null);
  const tableRef = useRef(null);
  const clientId = AuthService.getLoggedInClientId();

  const navigate = useNavigate();

  useEffect(() => {    
    const fetchProperties = async () => {
      try {
        const properties = await PropertyService.getPropertiesByClientId(clientId);
        setProperty(properties);
      } catch (error) {
        console.error('Error fetching Users: ', error);  
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch properties data' });
      }
    };
    fetchProperties();
    setTimeout(() => {
      $('#tableData').DataTable();
    }, 1000);
  }, [clientId]);

function renderProperties() {
  
    return Property.map((property) => {
    return (
      <tr key={property.id}>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.propertyName}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold"> {property.ownerName}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{`${property.streetAddress}, ${property.city}, ${property.state}, ${property.country}, ${property.postalCode}`}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.price}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.size}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.description}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.propertyType}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.yearBuilt}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.bedrooms}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{property.bathrooms}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold"><button
            className="btn btn-outline-dark btn-sm"
            onClick={() => navigate(`/editproperty/${property.id}`)}
          >
            <i className="pi pi-pencil" style={{ fontSize: '1.5rem' }}></i>
          </button>
          <button
            className="btn btn-outline-light btn-sm"
            onClick={() => deleteProperty(property.id)} style={{ marginLeft: '10px',paddingRight:'10px' }}
          >
            <i className="pi pi-trash" style={{ fontSize: '1.5rem', color: 'red' }}></i>
          </button></span>
        </td>
      </tr>
    );
  });
}

  const deleteProperty = async (propertyId) => {
    try {
      await PropertyService.deleteProperty(propertyId);
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Property deleted successfully', life: 3000 });
      setProperty(Property.filter(property => property.id !== propertyId));
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete Property', life: 3000 });
      console.log(e);
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className='form-group row'>
          <div className='col-lg-12 float-end'>
                      <div className='col-lg-3 float-end'>
                          <a class="btn bg-gradient-dark mb-0 float-end" href="javascript:;" onClick={() => {  navigate("/addproperty");}}>
                          <MdAddCircleOutline /> Add Property</a>
                      </div> 
           </div>
      </div>
      <div class="col-12">
          <div class="card my-4">
            <div class="card-body px-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0" id="tableData">
                  <thead>
                    <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Property Name</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Owner Name</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Address</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Price</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Size</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Description</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Property Type</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Year Built</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Bed Rooms</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Bath Roms</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {renderProperties()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Property;
